import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const DashboardTitle: React.FC = () => {
  const { t } = useTranslation();
  return (
    <motion.h3 
      className="text-lg font-bold text-[#181411] dark:text-white"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
    >
      {t('sidebar.title')}
    </motion.h3>
  );
};

export default DashboardTitle;